import { render, staticRenderFns } from "./price_plan_modal.vue?vue&type=template&id=5c979a82&"
import script from "./price_plan_modal.vue?vue&type=script&lang=js&"
export * from "./price_plan_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports